import { Box, Button, styled, TextField, Typography } from '@mui/material';

export const Wrapper = styled(Box)`
  height: 100vh;
  overflow: auto;
  display: flex;
  justify-content: center;
  text-align: center;
`;

export const Step = styled(Box)`
  position: fixed;
  width: 100%;
  margin: 0 auto;
  padding: 0 70px;
`;

export const LayoutTypeWrapper = styled(Box)`
  display: flex;
  gap: 30px;
  margin: 30px 0;
  padding: 3px;
  overflow-y: auto;
  overflow-x: hidden;

  button {
    padding: 20px;
    font-size: 1rem;
  }
`;

export const OptionWrapper = styled(Box)`
  display: grid;
  gap: 40px;
  width: fit-content;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: 1fr;
  button {
    font-size: 1rem;
  }
`;

export const ImageButton = styled(Button)(
  ({ theme, selected }) => `
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    gap: 45px;
    width: 100%;
    outline: 3px solid ${theme.palette.secondary.dark};
    background-color: ${theme.palette.secondary.contrastText};
    border-radius: 3px;
    color: ${theme.palette.secondary.dark};
    transition: all 0.1s ease-in-out;
    line-height:1;
    &:hover {
        outline: 3px solid ${theme.palette.primary.main};
        background-color: ${theme.palette.secondary.contrastText};
    }

    ${
      selected &&
      `
        outline: 3px solid ${theme.palette.primary.main};
        background-color: ${theme.palette.secondary.contrastText};
    `
    }
`,
);

export const LayoutButton = styled(Button)(
  ({ theme, selected }) => `
    display: flex;
    flex-direction: column;
    outline: 3px solid ${theme.palette.secondary.dark};
    background-color: ${theme.palette.secondary.contrastText};
    border-radius: 3px;
    color: ${theme.palette.secondary.dark};
    transition: all 0.1s ease-in-out;
    &:hover {
        outline: 3px solid ${theme.palette.primary.main};
        background-color: ${theme.palette.secondary.contrastText};
    }
    ${
      selected &&
      `outline: 3px solid ${theme.palette.primary.main};
      background-color: ${theme.palette.secondary.contrastText};`
    }
`,
);

export const StepContent = styled(Box)`
  margin: 30px 0;
  padding: 3px;
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const StepNavigation = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const StepNavigationButtonWrapperRight = styled(Box)`
  display: flex;
  justify-content: flex-end;
  gap: 20px;
`;

export const InputTextField = styled(TextField)(
  ({ theme }) => `
  width: 100%;
    && {
      input {
        background: ${theme.palette.secondary.lighter};
      }
    }
`,
);
export const InputTextLabel = styled(Typography)`
  font-size: 1.25rem;
  font-weight: 400;
  text-align: left;
`;

export const IconContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  padding: 20px;
`;

export const OutdoorIconContainer = styled(IconContainer)`
  padding: 0;
`;

export const MacCafeIconContainer = styled(IconContainer)`
  padding: 20px;
`;

export const ScreenContainer = styled(Box)`
  max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;
